import * as React from "react";
const SvgFiRrGhost = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M10 10.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 10 10.5M15.5 9a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 15.5 9m6.5 1v13a1 1 0 0 1-1 1 1 1 0 0 1-.942-.667C19.794 22.585 18.891 22 18.001 22s-1.793.585-2.057 1.333a1 1 0 0 1-1.886 0C13.794 22.585 12.891 22 12.001 22s-1.793.585-2.057 1.333a1 1 0 0 1-1.886 0C7.794 22.585 6.891 22 6.001 22s-1.793.585-2.057 1.333A1.001 1.001 0 0 1 2.001 23V10C2 4.486 6.486 0 12 0s10 4.486 10 10m-2 0c0-4.411-3.589-8-8-8s-8 3.589-8 8v10.503A4.3 4.3 0 0 1 6 20c1.127 0 2.222.472 3 1.225A4.38 4.38 0 0 1 12 20c1.127 0 2.222.472 3 1.225A4.38 4.38 0 0 1 18 20c.703 0 1.392.183 2 .503z"
    />
  </svg>
);
export default SvgFiRrGhost;
